import React from 'react';
import '../styles/MyDrawingSection.css';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import ShareIcon from '@material-ui/icons/Share';
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUpAltOutlined';
function Drawing({submittedBy,title}) {
    return (
        <div className="gallary_drawing">
                    <img src="https://fakeimg.pl/200/" alt='drawing'></img>
                    <div className="drawing_detail">
                        <div className="drawing_description">
                            <h5>Beautiful green city with a monkey on tree</h5>
                        </div>
                        <h6 style={{paddingLeft:"8px"}}>By: {submittedBy}</h6>
                        <div className="drawing_actions">
                        <ThumbUpAltOutlinedIcon style={{cursor:"pointer", color:"blue"}}/>
                        <FavoriteBorderIcon style={{cursor:"pointer", color:"red"}}/>
                        <ShareIcon style={{color:"blue",cursor:"pointer"}}/>
                        </div>                     
                    </div>
                </div>
    );
}

export default Drawing;